import React, {useMemo, useState} from 'react';
import {SecondaryButton, SkeletonLoader} from './index';
import {useQuery} from 'react-query';
import {useParams} from 'react-router-dom';
import {fetchAuthenticationActivity} from '../requests/queries/easyAuth';
import {useSelector} from 'react-redux';
import {getLighterShade} from '../routes/EasyOnboard/colorUtils';

const timelineLimit = 4;

const initialTimeline = [
  {
    datetime: 'Event_Date',
    event_value: 'Event_Description',
  },
  {
    datetime: 'Event_Date',
    event_value: 'Event_Description',
  },
];

function ActivityLog({title}) {
  const [next, setNext] = useState(timelineLimit);
  const {slug} = useParams();

  const {userDetails} = useSelector(state => state?.auth);
  const baseColor = userDetails?.company?.color_code || '#3f7cdb';

  const lighterShade = getLighterShade(baseColor, 93);

  const {data: timeline, isLoading} = useQuery(['activityLog', slug], () =>
    fetchAuthenticationActivity(slug),
  );

  const timeLineData = useMemo(
    () => (!isLoading && timeline && timeline?.data) || initialTimeline,
    [isLoading, timeline],
  );

  const handleLoadMore = () => {
    setNext(next + timelineLimit);
  };

  const LogData = useMemo(
    () => (isLoading ? ['1', '2', '3', '4'] : timeLineData?.slice(0, next)),
    [isLoading, next, timeLineData],
  );

  const SlimLoader = ({styles}) => (
    <SkeletonLoader
      style={{
        height: 10,
        width: 120,
        marginBottom: 0,
        ...styles,
      }}
    />
  );

  return (
    <div className="rounded-md my-5 bg-white80 overflow-hidden grow xl:grow-0  border border-[#E4E3E6] w-full">
      <div className="p-4   ">
        <p className="text-xs font-medium uppercase text-grey">
          {title || 'Activity log'}
        </p>
        <div className="mt-4">
          <div className="grid">
            {LogData?.map((time, index) => (
              <div
                key={index}
                className="activity-parent grid gap-[6px] grid-rows-[2rem] h-full py-[4px]"
              >
                <span
                  className="relative grid items-center text-xs font-medium text-body activity-time
              after:content-[''] after:absolute after:border-r after:border-dashed after:border-grey60 after:h-[40px] after:right-[-3px]"
                >
                  {isLoading ? (
                    <SlimLoader styles={{width: 50}} />
                  ) : (
                    <>
                      {time?.datetime?.split(' ')?.pop()?.replace('+00:00', '')}
                    </>
                  )}
                </span>
                <span
                  className="text-sm capitalize text-body activity-description leading-[12px]  relative grid items-center pl-2
              before:content-[''] before:absolute before:bg-brandBlue before:rounded-full before:w-[5px] before:h-[5px] before:top-1/2 before:left-[-3px] before:-mt-[1px] "
                >
                  {isLoading ? (
                    <SlimLoader styles={{width: 50 * (index + 1)}} />
                  ) : (
                    <>{time?.event_value ?? '-'}</>
                  )}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      {next < timeLineData?.length && (
        <div
          className="flex justify-end w-full  px-4 py-2"
          style={{backgroundColor: lighterShade}}
        >
          <SecondaryButton
            className="flex items-start gap-2"
            fontSize="text-xs"
            xPadding="px-2"
            yPadding="pt-[9px] pb-[7px]"
            btnHeight="h-7"
            buttonText="Load more"
            onClick={handleLoadMore}
          />
        </div>
      )}
    </div>
  );
}

export default ActivityLog;
